// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-circular-gradient-progress-bar .main-circular-gradient-progress-bar {
  border-radius: 50%;
  width: 120px;
  height: 120px;
  position: relative;
  margin-right: 20px;
  background: var(--circular-gradient-progress-bar-not-filled);
  z-index: 1;
}
.fi-circular-gradient-progress-bar .main-circular-gradient-progress-bar::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: var(--circular-gradient-progress-bar-filled);
  opacity: 0;
  transition: opacity 0.6s;
  z-index: -1;
  border-radius: 50%;
}
.fi-circular-gradient-progress-bar .main-circular-gradient-progress-bar.full-filled::before {
  opacity: 1;
}
.fi-circular-gradient-progress-bar .main-circular-gradient-progress-bar .progress-value-label {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: var(--fi-color-white);
  box-shadow: 0 5px 25px rgba(0, 0, 0, 0.1);
  width: 80px;
  height: 80px;
  border-radius: 50%;
  text-align: center;
  line-height: 80px;
  font-size: 22px;
}
.fi-circular-gradient-progress-bar .main-circular-gradient-progress-bar .gradient-progress-cover {
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 121px;
  height: 121px;
  transform: translate(-50%, -50%);
  background: conic-gradient(transparent 0deg, var(--fi-color-white) 0deg);
  transition: 0.2ms;
}
.fi-circular-gradient-progress-bar .main-circular-gradient-progress-bar .gradient-progress-cover .gradient-progress-cover-inner-circle {
  border-radius: 50%;
  width: 110px;
  height: 110px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: conic-gradient(transparent 0deg, var(--fi-color-alice-blue) 0deg);
  transition: 0.2ms;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/fi-circular-gradient-progress-bar/fi-circular-gradient-progress-bar.component.scss","webpack://./Source/app/shared/fi-shared-styles/fi-checklist-chart-backdrop-mixin.scss"],"names":[],"mappings":"AAGI;EACI,kBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,4DAAA;EACA,UAAA;AAFR;AAIQ;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,wDAAA;EACA,UAAA;EACA,wBAAA;EACA,WAAA;EACA,kBAAA;AAFZ;AAKQ;EACI,UAAA;AAHZ;AAMQ;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,uCAAA;EACA,yCAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AAJZ;AAOQ;EACI,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,aAAA;EACA,gCAAA;EACA,wEAAA;EACA,iBAAA;AALZ;AAOY;ECvDR,kBAAA;EACA,YDuDmF;ECtDnF,aDsDmF;ECrDnF,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,6EAAA;EDkDY,iBAAA;AAEhB","sourcesContent":["@use '../fi-shared-styles/fi-checklist-chart-backdrop-mixin';\r\n\r\n.fi-circular-gradient-progress-bar {\r\n    .main-circular-gradient-progress-bar {\r\n        border-radius: 50%;\r\n        width: 120px;\r\n        height: 120px;\r\n        position: relative;\r\n        margin-right: 20px;\r\n        background: var(--circular-gradient-progress-bar-not-filled);\r\n        z-index: 1;\r\n\r\n        &::before {\r\n            content: '';\r\n            position: absolute;\r\n            top: 0;\r\n            left: 0;\r\n            width: 100%;\r\n            height: 100%;\r\n            background: var(--circular-gradient-progress-bar-filled);\r\n            opacity: 0;\r\n            transition: opacity 0.6s;\r\n            z-index: -1;\r\n            border-radius: 50%;\r\n        }\r\n\r\n        &.full-filled::before {\r\n            opacity: 1;\r\n        }\r\n\r\n        .progress-value-label {\r\n            position: absolute;\r\n            top: 50%;\r\n            left: 50%;\r\n            transform: translate(-50%, -50%);\r\n            background-color: var(--fi-color-white);\r\n            box-shadow: 0 5px 25px rgba(0, 0, 0, 0.1);\r\n            width: 80px;\r\n            height: 80px;\r\n            border-radius: 50%;\r\n            text-align: center;\r\n            line-height: 80px;\r\n            font-size: 22px;\r\n        }\r\n\r\n        .gradient-progress-cover {\r\n            border-radius: 50%;\r\n            position: absolute;\r\n            top: 50%;\r\n            left: 50%;\r\n            width: 121px;\r\n            height: 121px;\r\n            transform: translate(-50%, -50%);\r\n            background: conic-gradient(transparent 0deg, var(--fi-color-white) 0deg);\r\n            transition: 0.2ms;\r\n\r\n            .gradient-progress-cover-inner-circle {\r\n                @include fi-checklist-chart-backdrop-mixin.fi-checklist-chart-backdrop(110px);\r\n                transition: 0.2ms;\r\n            }\r\n        }\r\n    }\r\n}\r\n","@mixin fi-checklist-chart-backdrop($size) {\r\n    border-radius: 50%;\r\n    width: $size;\r\n    height: $size;\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n    background: conic-gradient(transparent 0deg, var(--fi-color-alice-blue) 0deg);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
